var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 37,
    viewBox: "0 0 41 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.3 1.3125H18.175V10.6875L26.3 19.75L31.925 13.5H26.3V1.3125Z",
    fill: "#E71B4C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.425 36L25.3625 30.6875H34.1125V25.375H39.425V36H29.425Z",
    fill: "#E71B4C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2063 1H26.5188V13.3125H32.675L20.3625 25.625L8.05005 13.3125H14.2063V1Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 24.9375V36H39.725V24.9375H34.1938V30.4688H6.53125V24.9375H1Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download_icon.262fd9f1d219fd70b1d5f5e1f378f6b8.svg";
export { ForwardRef as ReactComponent };